import { isOneOf } from "@remi/ts-utils";

export const INBOX_SORTABLE_FIELDS = [
  "followUpDate",
  "createdAt",
  "priority",
  "status",
  "bidCreatedAt",
  "homeownerSentiment",
  "updatedAt",
  "lastCheckIn",
  "lastUnresolvedAt",
] as const;

export type InboxSortableField = (typeof INBOX_SORTABLE_FIELDS)[number];

export const isInboxSortableField = (field: string): field is InboxSortableField =>
  isOneOf(field, INBOX_SORTABLE_FIELDS);
